import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoadingSpinner from './LoadingSpinner';
import { SITE_LOGIN } from '../../config/siteLinks';

const ProtectedRoute = ({ children, role }) => {
  const { isAuthenticated, user, loading } = useAuth();

  if (loading) {
    return <LoadingSpinner fullPage />;
  }

  // Not signed in: send them to the role chooser, which is what they actually
  // need. It is served by IIS (not React Router), so this has to be a real
  // navigation rather than <Navigate>.
  if (!isAuthenticated) {
    window.location.replace(SITE_LOGIN);
    return <LoadingSpinner fullPage />;
  }

  if (role && user?.role !== role) {
    const redirectMap = {
      student: '/student/dashboard',
      teacher: '/teacher/dashboard',
      admin: '/admin/dashboard',
      superadmin: '/superadmin/dashboard',
      accountant: '/accountant/dashboard',
      instructor: '/instructor/dashboard',
    };
    const redirect = redirectMap[user?.role] || '/login';
    return <Navigate to={redirect} replace />;
  }

  return children;
};

export default ProtectedRoute;
